export const transactions = {
  series: [
    {
      name: "Total amount",
      data: [],
    },

  ],
  options: {
    chart: {
      height: 500,
      type: "bar",
      toolbar: {
        show: false,
        tools: {
          download: false,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          home: false,
          reset: false,
        },
      },
    },

    stroke: {
      curve: "smooth",
    },
    xaxis: {
      categories: [
    
      ],
    },

    dataLabels: {
      enabled: false,
    },
  },
}


export const assistant_performance = {
  series: [
    {
      name: "Debit",
      data: [44000, 55000, 57000, 56000, 61000, 58000, 63000, 60000, 66000],
    },
    {
      name: "credit",
      data: [35000, 41000, 36000, 26000, 45000, 48000, 52000, 53000, 41000],
    },
  ],
  options: {
    chart: {
      type: "bar",
      height: 450,
      toolbar: {
        show: false,
        tools: {
          download: false,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          home: false,
          reset: false,
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
  },
};


export const stock = {
  series: [
    {
      data: [21, 22, 10],
    },
  ],
  options: {
    chart: {
      height: 350,
      type: "bar",
      toolbar: {
        show: false,
        tools: {
          download: false,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          home: false,
          reset: false,
        },
      },
    },
    colors: ["#6CAF52", "#3A509F", "#C99D26"],
    plotOptions: {
      bar: {
        columnWidth: "45%",
        distributed: true,
      },
    },
    xaxis: {
      categories: ['Agent float allocation', 'Card top up', 'Agent float cash back', ],
    },
    dataLabels: {
      enabled: false,
    },
  },
}

